export const STATUS = {
  CREATED: 'created',
  SCHEDULED: 'scheduled',
  ACTIVATED: 'activated',
  EXPIRED: 'expired',
  DEACTIVATED: 'deactivated'
}
